/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_ConditionInputs */

const cs_form_condition = /** @type {(inputs: Form_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav`)
};

const en_form_condition = /** @type {(inputs: Form_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condition`)
};

/**
* | output |
* | --- |
* | "Condition" |
*
* @param {Form_ConditionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_condition = /** @type {((inputs?: Form_ConditionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_ConditionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_condition(inputs)
	return cs_form_condition(inputs)
});